import { Button } from "@progress/kendo-react-buttons";
import { DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Spinner from "../Common/Components/spinner";
import { getOptionsSelector, updateMdcDrillDown, updateCumuDataAs, updateMdcGroupingOptions, updateMdcGroupSize } from "../Common/Slices/optionSlice";
import { useAppDispatch } from "../Core/store.hooks";
import GroupingOptions from "./GroupingOptions";
import { Dialog } from "@progress/kendo-react-dialogs";


const ChartOptions = () => {
    const [drillDown, updateDrillDown] = useState("On");
    const [cumuDataAs, update_CumuDataAs] = useState("Raw");
    const [groupSize, updateGroupSize] = useState("None")
    const [visibleDialog, toggleDialog] = useState(false);
    const dispatch = useAppDispatch();

    const drillDownHandler = (e: any) => {
        //updateDrillDown(e.target.value)
        if (e.target.value === "On") {
            dispatch(updateMdcDrillDown(true));
        } else {
            dispatch(updateMdcDrillDown(false));
        }
    }
    const cumuDataAsHandler = (e: any) => {
        update_CumuDataAs(e.target.value);
        dispatch(updateCumuDataAs(e.target.value))
    }
    const groupSizeHandler = (e: any) => {
        updateGroupSize(e.target.value)
        dispatch(updateMdcGroupSize(e.target.value))
    }

    const toggleDialogHandler = () => {
        visibleDialog ? toggleDialog(false) : toggleDialog(true);
    };
    return (
        <div>
            <div className=" k-textbox-container metricComboSmall">
                <label className="k-label">GroupBy</label>
                <span
                    className="k-icon k-i-help"
                    onClick={() => toggleDialogHandler()}
                    style={{
                        cursor: "pointer",
                        position: "absolute",
                        top: "5px",
                        left: "60px",
                        fontSize: "11px",
                        marginTop: "-1px",
                        display: "inline-block",
                        verticalAlign: "top",
                    }}
                ></span>
                <DropDownList
                    data={["None", "Day", "Week", "Month", "Year"]}
                    value={groupSize}
                    onChange={groupSizeHandler}
                />
            </div>
            <div className=" k-textbox-container metricComboSmall">
                <label className="k-label">Drill Down</label>
                <DropDownList
                    data={["On", "Off"]}
                    value={drillDown}
                    onChange={drillDownHandler}
                />
            </div>
            <div className=" k-textbox-container metricCombo">
                <label className="k-label">Show cumulative data as</label>
                <DropDownList
                    data={["Raw","All time cumulative", "Range cumulative"]}
                    value={cumuDataAs}
                    onChange={cumuDataAsHandler}
                />
            </div>
            {visibleDialog && (
                <Dialog
                    title={"Grouping Options"}
                    onClose={toggleDialogHandler}
                    height={500}
                    width={600}
                >
                    <GroupingOptions />
                </Dialog>
            )}
        </div>
    )
    
}

export default ChartOptions;